import React, { useRef } from "react";
import styles from "./background.scss";
import { useSelector } from "react-redux";

const Background = (props) => {
  const { showModal, setShowModal, headerDesktopRef } = props;

  const modalRef = useRef(null);
  const announcement = useSelector(
    (state) => state && state.homeState && state.homeState.announcement
  );

  const closeModal = (e) => {
    if (modalRef.current === e.target) {
      setShowModal(false);
    }
  };

  // const getMarginTop = () => {
  //   const searchTop = headerDesktopRef.current.getBoundingClientRect().bottom;
  //   if (typeof window !== "undefined") {
  //     return searchTop;
  //   }
  // };

  return (
    <div
      className={styles["background"]}
      onClick={closeModal}
      ref={modalRef}
      // style={{ top: getMarginTop() }}
    >
      {props.children}
    </div>
  );
};

export { Background };
